import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const BodyRowRoot = styled.tr<{ showBottomBorder?: boolean }>(
    props =>
        props.showBottomBorder && {
            borderBottom: theme(props).tables.border.solid,
        }
);
